var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_69899",
    "data-name": "Raggruppa 69899",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34.747,
    height: 34.753,
    viewBox: "0 0 34.747 34.753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.288,
    y1: -0.462,
    x2: 1.661,
    y2: 1.251,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfa67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#c82c6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6325c4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_35806",
    "data-name": "Tracciato 35806",
    d: "M2461.479,1160.562q0-2.662,0-5.324a1.208,1.208,0,0,1,1.928-1.115q4.607,2.655,9.21,5.317a1.177,1.177,0,0,1,.622,1.61,1.8,1.8,0,0,1-.657.648c-2.465,1.443-4.941,2.865-7.415,4.293-.6.344-1.191.691-1.791,1.03a1.2,1.2,0,0,1-1.9-1.1Q2461.476,1163.24,2461.479,1160.562Z",
    transform: "translate(-2448.989 -1138.905)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_35805",
    "data-name": "Tracciato 35805",
    d: "M2449.217,1139.235h-23.069a1.745,1.745,0,0,0-.226-.061,6.434,6.434,0,0,1-5.6-6.3q-.027-11.01,0-22.021a6.419,6.419,0,0,1,6.365-6.363q10.991-.028,21.983,0a6.41,6.41,0,0,1,6.128,4.68c.107.377.173.767.258,1.151V1133.4c-.022.086-.049.171-.064.258a6.357,6.357,0,0,1-4.362,5.237A12.7,12.7,0,0,1,2449.217,1139.235Zm-26.512-23.767v.4q0,8.347,0,16.694a4.089,4.089,0,0,0,4.264,4.276q10.72,0,21.44,0a4.085,4.085,0,0,0,4.249-4.258q0-8.364,0-16.728v-.388Zm19.355-8.587c.063.108.082.149.108.184q2.14,2.9,4.289,5.8a.557.557,0,0,0,.4.167c1.83.011,3.66.008,5.49.006.1,0,.194-.015.352-.027a23.051,23.051,0,0,0-.135-2.821,4,4,0,0,0-4.047-3.309c-2.033-.011-4.067,0-6.1,0Zm-8.784,6.145a.729.729,0,0,0-.053-.122q-2.161-2.932-4.329-5.859a.483.483,0,0,0-.335-.156c-.61-.014-1.22-.02-1.83,0a4.076,4.076,0,0,0-3.833,2.865,13.1,13.1,0,0,0-.194,3.275Zm10.32.017c-1.509-2.046-2.962-4.021-4.428-5.988a.56.56,0,0,0-.4-.167c-2.227-.01-4.455-.007-6.682-.006-.083,0-.166.016-.277.027.047.08.071.13.1.174q2.124,2.879,4.244,5.761a.485.485,0,0,0,.459.2q3.307-.006,6.615,0Z",
    transform: "translate(-2420.305 -1104.482)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReel);
export default __webpack_public_path__ + "static/media/reel.027c76c1e84a7e41d271fb29ae1e6b1b.svg";
export { ForwardRef as ReactComponent };